import React from 'react'
import { withRouter } from 'react-router-dom'

import firebase from 'helpers/firebase'

import { withStyles } from 'material-ui/styles'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Menu, { MenuItem } from 'material-ui/Menu'
import Typography from 'material-ui/Typography'
import IconButton from 'material-ui/IconButton'
import AccountCircle from '@material-ui/icons/AccountCircle'
import MenuIcon from '@material-ui/icons/Menu'

import { getRouteTitle } from '../helpers/nav'
import { firstString } from '../helpers/conditional'
import styles from '../styles/components/Header'

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      title: getRouteTitle(props.location.pathname),
      anchorEl: null
    }

    this.props.history.listen(location => {
      this.setState({
        title: getRouteTitle(location.pathname)
      })
    })
  }

  handleUserMenuAction = action => () => {
    this.setState({ anchorEl: null }, () => {
      setTimeout(action, 50)
    })
  }

  handleOpenUserMenu = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleCloseUserMenu = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { title, anchorEl } = this.state
    const { classes, editUser, toggle, user } = this.props

    const open = Boolean(anchorEl)

    return (
      <React.Fragment>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={toggle}
              className={classes.navIconHide}
            >
              <MenuIcon />
            </IconButton>

            <div className={classes.headerSpreader}>
              <Typography variant="title" color="inherit" noWrap>
                {title}
              </Typography>
              <div className={classes.userBlock}>
                <Typography color="inherit">
                  {firstString(user.displayName, user.email)}
                </Typography>
                <IconButton
                  aria-owns={open ? 'menu-appbar' : null}
                  aria-haspopup="true"
                  onClick={this.handleOpenUserMenu}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                  open={open}
                  onClose={this.handleCloseUserMenu}
                >
                  <MenuItem onClick={this.handleUserMenuAction(editUser)}>
                    Profile
                  </MenuItem>
                  <MenuItem
                    onClick={this.handleUserMenuAction(() => {
                      firebase.auth().signOut()
                    })}
                  >
                    Sign Out
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </Toolbar>
        </AppBar>
      </React.Fragment>
    )
  }
}

export default withStyles(styles, { withTheme: true })(withRouter(Header))



// WEBPACK FOOTER //
// ./src/components/Header.jsx